import type { FC } from 'react'
import React, { memo } from 'react'
import { IndexPageSection, SectionBlock } from '@/pages/IndexPage/components/'
import { FundingBanner } from './components/FundingBanner'
import './styles.scss'

const AboutMarketplace: FC = () => {
  return (
    <IndexPageSection className="aboutMarketplace">
      <SectionBlock>
        <FundingBanner />
      </SectionBlock>
    </IndexPageSection>
  )
}

export default memo(AboutMarketplace)
